import * as yup from 'yup';
export const sendgridEventSchema = yup.object().shape({
    event: yup.string().required(),
    email: yup.string().required(),
    event_timestamp: yup.date(),
    response: yup.string(),
    attempt: yup.string(),
    reason: yup.string(),
    reason_full: yup.string(),
    id: yup.string().required(),
});
//# sourceMappingURL=sendgridEvent.js.map